import {
    FormControl,
    FormHelperText,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
} from '@mui/material';
import { FC, useState, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import ClearIcon from '@mui/icons-material/Clear';
import JiraIssueSelectorMenu from './JiraIssueSelectorMenu';
import { JiraIssue } from '../types';

interface JiraIssueSelectorProps {
    value: JiraIssue | null;
    onChange: (issue: JiraIssue | null) => void;
    error?: boolean;
    helperText?: string;
}

const JiraIssueSelector: FC<JiraIssueSelectorProps> = ({ value, onChange, error, helperText }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleClear = () => onChange(null);

    const handleMouseDownClear = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleSelect = (issue: JiraIssue) => {
        onChange(issue);
        setOpen(false);
    };

    return (
        <FormControl fullWidth size="small" error={error}>
            <InputLabel id="jira-issue-select">{t('jira_issue')}</InputLabel>
            <Select
                labelId="jira-issue-select"
                value={value ? ' ' : ''}
                renderValue={() => {
                    if (!value) return '';
                    return value.key;
                }}
                open={open}
                onOpen={handleOpen}
                onClose={handleClose}
                input={
                    <OutlinedInput
                        sx={{
                            '& .MuiSelect-select': {
                                paddingRight: '0 !important',
                            },
                        }}
                        label={t('jira_issue')}
                        endAdornment={
                            value && (
                                <InputAdornment position="start" sx={{ mr: 2 }}>
                                    <IconButton size="small" onClick={handleClear} onMouseDown={handleMouseDownClear}>
                                        <ClearIcon />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }
                    />
                }
                MenuProps={{
                    PaperProps: {
                        sx: {
                            height: 400,
                            width: 400,
                        },
                    },
                }}
            >
                <MenuItem sx={{ position: 'absolute', visibility: 'hidden' }} value={' '} />
                <JiraIssueSelectorMenu open={open} onClose={handleClose} onChange={handleSelect} />
            </Select>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default JiraIssueSelector;
